import { useMutation } from '@tanstack/react-query';
import { SendApi } from 'api';
import type { SendEmail, SendSMS, SendPushMessage } from 'api/methods/SendApi';

/**
 * [Email] 이메일 전송
 * --
 */
export const useSendEmail = (options?: { [key: string]: () => void }) => {
  const { mutateAsync: sendEmail, ...result } = useMutation({
    mutationFn: (variables: SendEmail) => SendApi.sendEmail(variables),
    ...options,
  });

  return { sendEmail, ...result };
};

/**
 * [SMS] 문자 전송
 * --
 */
export const useSendSMS = (options?: { [key: string]: () => void }) => {
  const { mutateAsync: sendSMS, ...result } = useMutation({
    mutationFn: (variables: SendSMS) => SendApi.sendSMS(variables),
    ...options,
  });

  return { sendSMS, ...result };
};

/**
 * [Push] 푸시알림 전송
 * --
 */
export const useSendPushMessage = (options?: { [key: string]: () => void }) => {
  const { mutateAsync: sendPushMessage, ...result } = useMutation({
    mutationFn: (variables: SendPushMessage) =>
      SendApi.sendPushMessage(variables),
    ...options,
  });

  return { sendPushMessage, ...result };
};
